import { render, staticRenderFns } from "./CertificateDebt.vue?vue&type=template&id=01d9f1b0&"
import script from "./CertificateDebt.vue?vue&type=script&lang=js&"
export * from "./CertificateDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports